import { createContext, useContext, type ParentComponent } from 'solid-js';
import type { ThemeStore } from './store';
import { createThemeStore } from './store';

// Create context
const ThemeContext = createContext<ThemeStore | undefined>(undefined);

// Provider component
export const ThemeProvider: ParentComponent = props => {
  const store = createThemeStore();

  return <ThemeContext.Provider value={store}>{props.children}</ThemeContext.Provider>;
};

// Hook to use theme
export function useTheme(): ThemeStore {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
